import { useMemo, useState } from 'react';
import { Button, Popover } from '@mantine/core';
import { FiChevronDown } from 'react-icons/fi';
import { TbListDetails } from 'react-icons/tb';
import { t } from 'i18next';
import { usePluginLogs } from '@morph-mapper/plugins';
import { PluginLogList } from '../../../common/features/plugin-progress';

/**
 * The plugin logs in the editor's header: a button with the count that opens
 * them in a dropdown, in the same scroll box as on the Loading Plugins step.
 * Hidden until a plugin has logged something.
 */
export const PluginLogsMenu = () => {
  const logs = usePluginLogs();
  const [opened, setOpened] = useState(false);
  const ordered = useMemo(
    () => [...logs].sort((a, b) => a.time - b.time),
    [logs],
  );

  if (logs.length === 0) return null;

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom"
      width={560}
      shadow="md"
      withinPortal
    >
      <Popover.Target>
        <Button
          variant="default"
          leftIcon={<TbListDetails size={18} />}
          rightIcon={
            <FiChevronDown
              size={14}
              style={{
                transform: opened ? 'rotate(180deg)' : undefined,
                transition: 'transform 150ms ease',
              }}
            />
          }
          onClick={() => setOpened((o) => !o)}
          aria-expanded={opened}
          aria-haspopup="dialog"
        >
          {t('title.logs')} ({logs.length})
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <PluginLogList logs={ordered} />
      </Popover.Dropdown>
    </Popover>
  );
};
